import { FormElementChoicePriorityModel } from './form-element-choice-priority.model';

export class QuestionChoiceModel {
  id: string;
  text: string;
  impact: string;
  orderIndex: number;
  formElementChoicePriority: Array<FormElementChoicePriorityModel>;
  constructor(id: string = undefined) {
    this.impact = 'NoImpact';
    this.id = id;
  }
}
